import _ from 'lodash'
import React, { Component } from 'react'
import { Col, Row, FormGroup } from "react-bootstrap"
import {  Field, reduxForm, propTypes,formValueSelector,getFormSyncErrors,change   } from 'redux-form'
import { bindActionCreators } from 'redux'
import { connect } from 'react-redux'
import { PropTypes } from 'prop-types'
import { 
	savingSeasonRankingPoints,
	saveSeasonRankingPoints,
	setRankingPointsFile,
	resetRankingPoints ,
	fetchSeasonRankingPoints,
	gettingSeasonRankingPoints
} from "../../../redux/actions/action_seasonsettings"
import { defaultformstate } from '../../../utils/statedefaultvalues/formstate'
import { warning,green } from '../../../utils/sitecolors'
import RankingSettings  from './RankingSettings'
import InfoSaved from './InfoSaved'
import ErrorList from './ErrorList'
import { field_file }  from './FileInput'


const formName = 'seasonranking'

const comboStyle = {
    minHeight:'37px',paddingLeft:'10px', minWidth:'100px', borderColor:'#C3C3C3', borderRadius:'3px'
}

class Ranking extends Component {
	static propTypes = {
			...propTypes
	}
	constructor(props,context)
	{
		super(props,context)
		this.handleValueChange   				= this.handleValueChange.bind(this)
		this.seasonOptions       				= this.seasonOptions.bind(this)
		this.tierOptions         				= this.tierOptions.bind(this)
		this.handleSaveTemplate 				= this.handleSaveTemplate.bind(this)
		this.handleOnFileChange 				= this.handleOnFileChange.bind(this)
		this.handleSelectedFilterChange = this.handleSelectedFilterChange.bind(this)	
		this.handleGetSeasonRankingPoints = this.handleGetSeasonRankingPoints.bind(this)		
	}
	componentDidUpdate()
	{
		const {  initialize,datasaved } = this.props
		if (datasaved) {
				initialize({}, true)
		}
	}
	tierOptions() 
	{
		const tiers= [{ id:'1',description:'Tier 1' },{ id:'2',description:'Tier 2' }]
		const option = tiers.map((tier) => {
				return (<option key={tier.id} value={tier.id}>{tier.description}</option>)
		})
		return option
	}
	seasonOptions()
	{
		const { seasons } = this.props
		const seasondatesarray = Object.values(seasons)
		const option = seasondatesarray.map((season) => {
			return (<option key={season.id} value={season.id}>{season.description}</option>)
		})
		return option
	}	
	handleValueChange()
	{
		this.props.dispatch(change(formName,'datasaved',false))
	}
	handleOnFileChange(file)
	{
		const { dispatch } = this.props
		const { target } 	 = file
		const fileSelected = target.files.length !== 0 ? true:false
		const filename 		 =  fileSelected == true ? target.files[0].name:''
		dispatch(resetRankingPoints())
		dispatch(setRankingPointsFile(filename))
	}
	handleSaveTemplate(data) {
		const { dispatch } = this.props
		// console.log('handleSaveTemplate data',data.rankingfile[0])
		if (data.rankingfile)
		{
			const { tier, rankingfile,settingsseason } = data
			dispatch(savingSeasonRankingPoints())
			const formData = new FormData()
			formData.append('tier', parseInt(tier))
			formData.append('season',parseInt(settingsseason))
			formData.append('rankingfile', rankingfile[0])
			dispatch(saveSeasonRankingPoints(formData))
		}

	}   
	handleGetSeasonRankingPoints(e) {
		const { dispatch,settingsseason,tier } = this.props
		e.preventDefault()
		dispatch(gettingSeasonRankingPoints())
		dispatch(fetchSeasonRankingPoints(settingsseason,tier))
	}
	handleSelectedFilterChange() {
		const { dispatch } = this.props
		dispatch(resetRankingPoints())
	}
	render() {
		const { 
			rankingfilename,rankingpoints,seasons, savingdata,datasaved,settingsseason,tier,gettingRankingPoints,noRankingPointsFound,
			syncErrors,handleSubmit 
		} = this.props
		const pointsAvailable = (rankingpoints != undefined) && (_.isEmpty(rankingpoints) == false)

		const errors =  Object.values(syncErrors)
		let isSeasonSet = true
		const rankingPointsSelected = ((rankingfilename == undefined) || (rankingfilename.length == 0)) ? false:true
		const fileMessage = rankingPointsSelected == true ? rankingfilename:'No file selected'
		const fileMessageColor = rankingPointsSelected  == true? green:warning
		let seasonDescription = ''
		//console.log('Inside ranking render rankingpoints,pointsAvailable',rankingpoints,pointsAvailable)
		if((seasons != undefined) && (settingsseason != undefined))
		{
			const season = _.find(seasons,{ 'id': parseInt(settingsseason) })
			isSeasonSet = season.isSeasonSet
			seasonDescription = season.description
		}     
		return (
		<form id='seasonranking' encType="multipart/form-data" onSubmit={handleSubmit(this.handleSaveTemplate)} className="form-horizontal" sm={12} style={{ padding:'0',margin:'0' }} >
			<Row className="center-block center-text">
				<Col xs={12}>
					<Row>
						<Col xs={12}>
							{ (errors.length > 0) && <ErrorList errors={errors} offset='col-sm-offset-0'/> }
								<div className="stacked-filter-panel">
									<FormGroup controlId="searchby" className="searchby-filter">
										<FormGroup>
											<Col>
												<Field name='settingsseason' 
													component="select" 
													disabled={savingdata}
													onChange={this.handleSelectedFilterChange}
													style={Object.assign({},comboStyle,{ borderTopRightRadius:'0',borderBottomRightRadius:'0' })}
													value={settingsseason}
												>
													{seasons != undefined && this.seasonOptions()}
												</Field>														
												<Field name='tier' 
													component="select" 
													disabled={savingdata}
													onChange={this.handleSelectedFilterChange}
													style={Object.assign({},comboStyle, { borderRadius:'0' ,marginRight:'-25px' })}
													value={tier}
												>
													{seasons != undefined && this.tierOptions()}
												</Field>    																				
											</Col>
										</FormGroup>
										<button className="btn btn-primary" onClick={this.handleGetSeasonRankingPoints} disabled={savingdata} style={{ width:'240px',minHeight:'38px',borderRadius:'0',marginRight:'1px',fontSize:'16px' }}>
											<i className={gettingRankingPoints == true?  "fa fa-spinner fa-spin":"fa fa-trophy"} aria-hidden="true" />&nbsp;{' '}View Current Ranking Points
										</button>
										<label className="btn btn-primary" style={{ minWidth:'290px',borderRadius:'0', minHeight:'38px',fontSize:'16px' }} disabled={savingdata}>
											<i className="fa fa-file-excel-o" aria-hidden="true" />&nbsp;{' '}Select Ranking Points File (.xlsx) {' '}
											<Field type='file' component={field_file} accept=".xlsx" name='rankingfile' onChange={this.handleOnFileChange} />						
										</label>
										<label style={{ minWidth:'240px',color:fileMessageColor }}>{fileMessage}</label>
									
									</FormGroup>
								</div>
						</Col>
					</Row>
				
					{
						((pointsAvailable == true) && (<RankingSettings tier={tier} settingsseason={seasonDescription} rankingpoints={rankingpoints}/>))
					}
					{
						((noRankingPointsFound == true) && (<div className='pull-left col-sm-12'><h4 style={{ color:warning }}><i className="fa fa-exclamation" aria-hidden="true" />&nbsp;{' '} No Ranking Points have been uploaded for {seasonDescription} Season, Tier {tier}</h4></div>))
					}
					<FormGroup>
						<Col sm={12}>
							<button type="submit" className="btn btn-primary" style={{ marginLeft:'20px',marginTop:'5px' }}
									onClick={this.handleSaveTemplate} disabled={datasaved || !isSeasonSet || !rankingPointsSelected}>
									<i className={savingdata == true? 'fa fa-spinner fa-spin':"fa fa-cogs"} aria-hidden="true" /> &nbsp;&nbsp;Save Settings
							</button>
							{
									datasaved && (<InfoSaved section='Season ranking' />)
							}
						</Col>                        
					</FormGroup>
				</Col>
			</Row>
		</form>
		)
	}
}
function validate(values) {
	const { settingsseason,seasons } = values
	const errors = {}

	if((seasons != undefined) && (settingsseason != undefined)) {		
		const season          =  _.find(seasons,{ 'id': parseInt(settingsseason) })
		const { isSeasonSet }  = season
		let errorCounter       = 0    
		
		if ((isSeasonSet != undefined) && (!isSeasonSet)) {
			errors[errorCounter++]  = "Initiate the season by clicking 'Setup season' in the Season Dates tab before uploading ranking settings"
		}		
	}
	return errors
} 
Ranking.propTypes = {
	dispatch:PropTypes.func,
	setRankingPointsFile:PropTypes.func,
	gettingSeasonRankingPoints:PropTypes.func,
	fetchSeasonRankingPoints:PropTypes.func,
	handleSubmit:PropTypes.func,
	initialize:PropTypes.func,
	savingSeasonRankingPoints:PropTypes.func,
	saveSeasonRankingPoints:PropTypes.func,
	resetRankingPoints:PropTypes.func,
	syncErrors:PropTypes.object,
	rankingpoints:PropTypes.object,
  savingdata:PropTypes.bool,
	datasaved:PropTypes.bool,
	noRankingPointsFound:PropTypes.bool,
	gettingRankingPoints:PropTypes.bool,
  seasons:PropTypes.array,
  settingsseason:PropTypes.string,
  tier:PropTypes.string,
  rankingfilename:PropTypes.string
 }

function mapStateToProps(state,ownProps){
	const formName =  ownProps.form
	const selector = formValueSelector(formName)
	const settingsseason = selector(state,'settingsseason')
	const seasons     = selector(state,'seasons')
	const savingdata     = selector(state,'savingdata')
	const gettingRankingPoints     = selector(state,'gettingRankingPoints')
	const datasaved     = selector(state,'datasaved')
	const syncErrors = getFormSyncErrors(formName)(state)
	const tier     = selector(state,'tier')
	const rankingpoints    = selector(state,'rankingpoints')
	const rankingfilename    = selector(state,'rankingfilename')
	const noRankingPointsFound    = selector(state,'noRankingPointsFound')
	return {     
		settingsseason,
		seasons,
		savingdata,
		gettingRankingPoints,
		datasaved,
		syncErrors,
		tier,
		rankingpoints,
		rankingfilename,
		noRankingPointsFound  
	}
}
function mapDispatchToProps(dispatch){
	return bindActionCreators({
		savingSeasonRankingPoints,
		saveSeasonRankingPoints,
		resetRankingPoints,
		setRankingPointsFile,
		fetchSeasonRankingPoints,
		gettingSeasonRankingPoints
	},dispatch)
}
export default reduxForm({
  validate,
  form:formName,
  destroyOnUnmount: true,
  forceUnregisterOnUnmount: false,
  initialValues:defaultformstate,
  enableReinitialize: true
})(connect(mapStateToProps,mapDispatchToProps)(Ranking))




// WEBPACK FOOTER //
// ./src/containers/season/Components/Ranking.js